<template>
    <CardPage :section="10" :page="8" :nextDisabled="nextDisabled" ref="cardPage">
        <p>
            As you saw having anal sex without a condom is considered to be a higher risk sexual activity. What are some of the things you can do to decrease
            the risk of engaging in anal sex? Pick 3 strategies that you could use.
        </p>

        <div
            v-for="strategy in strategies"
            :key="strategy.id"
            @click.stop="select(strategy)"
            class="grey pa-3 mb-1 response"
            :class="{ 'lighten-3': !isSelected(strategy), success: isCorrectAlreadySelected(strategy) }"
            v-ripple
        >
            <span :class="{ 'incorrect-selected': isIncorrectAlreadySelected(strategy) }">{{ strategy.strategy }}</span>
        </div>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter } from 'lodash';

export default {
    data() {
        return {
            selectedStrategies: []
        };
    },
    computed: {
        strategies: sync('section10/assSexStrategies')
    },
    methods: {
        nextDisabled() {
            return filter(filter(this.strategies, ['picked', false]), 'correct').length > 0;
        },
        select(strategy) {
            if (!this.selectedStrategies.includes(strategy.id)) {
                this.$refs.modalFeedback.show(strategy.correct, strategy.text);

                this.strategies[strategy.id].picked = true;

                this.selectedStrategies.push(strategy.id);
            }
        },
        isSelected(strategy) {
            return this.selectedStrategies.includes(strategy.id);
        },
        isIncorrectAlreadySelected(strategy) {
            return this.selectedStrategies.includes(strategy.id) && !strategy.correct;
        },
        isCorrectAlreadySelected(strategy) {
            return this.selectedStrategies.includes(strategy.id) && strategy.correct;
        }
    }
};
</script>

<style scoped>
.incorrect-selected {
    text-decoration: line-through;
    text-decoration-color: red;
}
</style>
